;(function () {

	'use strict';

	var offCanvas = function() {
		$('body').on('click', '.fight-nav-toggle', function(event){
			var $this = $(this);

			$('.fight-offcanvas').toggleClass('fight-awake');
			$('.fight-page, .fight-header').toggleClass('fight-sleep');


			if ( $('.fight-offcanvas').hasClass('fight-awake') ) {
				$this.addClass('active');
			} else {
				$this.removeClass('active');
			}
			event.preventDefault();
		})
	};


	var fixedHeader = function() {
		var $header = $('.fight-header');

		var hh = $header.innerHeight();

		$('.fight-main-content').css({
			paddingTop : hh + 'px'
		});

		$(window).scroll(function(){
			var tbh = $('.fight-top-bar').innerHeight();

			if ( $(window).scrollTop() > tbh ) {
				$header.addClass('sleep');
			} else {
				$header.removeClass('sleep');
			}

		});


		$(window).resize(function(){
			var hh = $('.fight-header').innerHeight();
			$('.fight-main-content').css({
				paddingTop: hh + 'px'
			});
		});
	};

	var fixedFooter = function() {
		var fh = $('.fight-footer').innerHeight();
		var wh = $('body').innerHeight();

		$('.fight-main-content').css({
			marginBottom: fh + 'px',
			minHeight: wh + 'px'
		});

		if ( $(window).width() < 991 ) {
			$('.fight-main-content').css({
				marginBottom: ''
			})
		}

		$(window).resize(function(){
			var fh = $('.fight-footer').innerHeight();
			var wh = $('body').innerHeight();
			$('.fight-main-content').css({
				marginBottom: fh + 'px',
				minHeight: wh + 'px'
			});
			if ( $(window).width() < 991 ) {
				$('.fight-main-content').css({
					marginBottom: ''
				})
			}
		});
	};


	$(function () {
		offCanvas();
		fixedHeader();
		fixedFooter();
	});

}());